var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.itemId
    ? _c(
        "div",
        { staticClass: "widget-danger" },
        [
          _vm.responseCode !== 1
            ? _c("p", {
                staticClass: "notification-text",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate(
                      "Ecomsilio::Template.availabilityNotification"
                    )
                  ),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.responseCode >= 1 && _vm.responseCode <= 6
            ? [
                _vm.responseCode === 1
                  ? _c("p", { staticClass: "notification-success" }, [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$translate(
                              "Ecomsilio::Template.availabilityNotificationMessage1"
                            )
                          ) +
                          "\n    "
                      ),
                    ])
                  : _vm.responseCode === 2
                  ? _c("p", { staticClass: "notification-error" }, [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$translate(
                              "Ecomsilio::Template.availabilityNotificationMessage2"
                            )
                          ) +
                          "\n    "
                      ),
                    ])
                  : _vm.responseCode === 3
                  ? _c("p", { staticClass: "notification-error" }, [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$translate(
                              "Ecomsilio::Template.availabilityNotificationMessage3"
                            )
                          ) +
                          "\n    "
                      ),
                    ])
                  : _vm.responseCode === 5
                  ? _c("p", { staticClass: "notification-error" }, [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$translate(
                              "Ecomsilio::Template.availabilityNotificationMessage5"
                            )
                          ) +
                          "\n    "
                      ),
                    ])
                  : _vm.responseCode === 6
                  ? _c("p", { staticClass: "notification-error" }, [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$translate(
                              "Ecomsilio::Template.availabilityNotificationMessage6"
                            )
                          ) +
                          "\n    "
                      ),
                    ])
                  : _vm.responseCode === 9
                  ? _c("p", { staticClass: "notification-error" }, [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$translate(
                              "Ecomsilio::Template.availabilityNotificationMessage6"
                            )
                          ) +
                          "\n    "
                      ),
                    ])
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.responseCode !== 1
            ? _c(
                "form",
                {
                  ref: "availabilityNotificationForm",
                  staticClass: "row mb-3",
                  attrs: { autocomplete: "on", method: "post" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.validateNotificationForm()
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-6 col-md-12 col-lg-6 mb-3 mb-sm-0 mb-md-3 mb-lg-0 pr-lg-2",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.username,
                            expression: "username",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          "data-validate": "mail",
                          name: "email",
                          required: "required",
                          type: "email",
                          placeholder: _vm.$translate(
                            "Ceres::Template.contactMail"
                          ),
                          "aria-required": "true",
                          "aria-label": _vm.$translate(
                            "Ceres::Template.contactMail"
                          ),
                          autocomplete: "email",
                          disabled: _vm.isSendingData,
                        },
                        domProps: { value: _vm.username },
                        on: {
                          focus: function ($event) {
                            _vm.loadRecaptcha = true
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.username = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-6 col-md-12 col-lg-6 pl-lg-0",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-block btn-default btn-appearance",
                          attrs: {
                            "aria-label": _vm.$translate(
                              "Ecomsilio::Template.availabilityNotificationSubmitButton"
                            ),
                          },
                        },
                        [
                          _c("icon", {
                            attrs: {
                              icon: "fa-paper-plane-o",
                              loading: _vm.isSendingData,
                            },
                          }),
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$translate(
                                  "Ecomsilio::Template.availabilityNotificationSubmitButton"
                                )
                              ) +
                              "\n      "
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  !!_vm.googleRecaptchaApiKey && _vm.loadRecaptcha
                    ? _c("recaptcha")
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("hr", { staticClass: "widget widget-separator mb-3 clearboth" }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }